import { confirm } from '@/shared/ui/dialog'

/**
 * Aviso de versão com mudanças importantes.
 *
 * Deriva do diálogo imperativo do DS em vez de um componente próprio: o
 * `DialogHost` já está montado no `AppShell`, e a única coisa específica desta
 * feature é o texto e o que fazer com a resposta.
 *
 * É puramente informativo. "Agora não" não cancela a atualização nem bloqueia
 * ação nenhuma — a versão pendente cai na camada automática e recarrega no
 * próximo momento ocioso. Bloquear ação por tipo de release foi cortado do
 * escopo de propósito: exigiria manter uma lista de "ações críticas" que cresce
 * a cada feature nova.
 */
export const showUpdateModal = () =>
  confirm({
    title: 'Nova versão disponível',
    description:
      'Essa atualização traz mudanças importantes. Você pode atualizar agora ou continuar — a atualização será aplicada sozinha assim que você não estiver no meio de nada.',
    variant: 'info',
    confirmLabel: 'Atualizar agora',
    cancelLabel: 'Agora não',
    showCancel: true
  })
